"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = void 0;
exports.ContentTypeFromJSON = ContentTypeFromJSON;
exports.ContentTypeFromJSONTyped = ContentTypeFromJSONTyped;
exports.ContentTypeToJSON = ContentTypeToJSON;
exports.ContentTypeToJSONTyped = ContentTypeToJSONTyped;
/**
 * Type of content
 * @export
 * @enum {string}
 */
var ContentType;
(function (ContentType) {
    ContentType["News"] = "news";
    ContentType["Celeb"] = "celeb";
    ContentType["Gallery"] = "gallery";
    ContentType["Longvideo"] = "longvideo";
    ContentType["Promo"] = "promo";
    ContentType["Character"] = "character";
    ContentType["MinuteByMinute"] = "minute_by_minute";
    ContentType["Post"] = "post";
})(ContentType || (exports.ContentType = ContentType = {}));
function ContentTypeFromJSON(json) {
    return ContentTypeFromJSONTyped(json, false);
}
function ContentTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ContentTypeToJSON(value) {
    return ContentTypeToJSONTyped(value, false);
}
function ContentTypeToJSONTyped(value, ignoreDiscriminator = false) {
    return value;
}
